import * as React from 'react'; // eslint-disable-line
import styled from 'styled-components';
import { ANIMATION, COLOR, FONT_SIZE, SPACING_SCALE, SPEED } from '../../packages/constants';

export interface StepProcessProps {
    /**
     * Step data
     */
    steps: any;
    /**
     * Index of current step
     */
    currentStep: number;
}

interface StepItemsProps {
    childLength: number;
    active: boolean;
    complete: boolean;
}

const roundelSize = 22;

const StyledStepProcess = styled.ol`
    margin: 0 auto ${SPACING_SCALE * 6}px;
    width: 100%;
    min-height: 64px;
    overflow: hidden;
`;

const StyledLabel = styled.p`
    line-height: ${FONT_SIZE.MEDIUM};
    display: inline-block;
    max-width: 50%;
`;

const StyledStepItem = styled.li<StepItemsProps>`
    list-style-type: none;
    width: ${(props: StepItemsProps): string => `${100 / props.childLength}%`};
    float: left;
    font-size: ${FONT_SIZE.SMALL};
    position: relative;
    text-align: center;
    text-transform: uppercase;
    color: ${(props) =>
        props.active || props.complete ? props.theme.main || COLOR.BRAND.REPORTING : COLOR.MAIN.FORM_FIELD_DARK};
    box-sizing: border-box;

    &::before {
        width: ${roundelSize}px;
        height: ${roundelSize}px;
        content: '';
        counter-increment: step;
        line-height: ${roundelSize}px;
        border-width: 2px;
        border-style: solid;
        border-color: ${(props) =>
            props.active || props.complete ? props.theme.main || COLOR.BRAND.REPORTING : COLOR.MAIN.FORM_FIELD_DARK};
        display: block;
        text-align: center;
        margin: 0 auto 10px;
        border-radius: 50%;
        background-color: ${(props) =>
            props.complete ? props.theme.main || COLOR.BRAND.REPORTING : COLOR.PRIMARY.WHITE};
        box-sizing: border-box;
        animation: ${SPEED.TRANSITION} ${ANIMATION.FADE_IN} linear forwards;
        position: relative;
        z-index: 1;
    }

    &::after {
        background-color: ${(props) => (props.complete ? props.theme.main || COLOR.BRAND.REPORTING : 'transparent')};
        width: 100%;
        height: 2px;
        content: '';
        position: absolute;
        border-top: ${(props: StepItemsProps): string =>
            props.complete ? '2px solid transparent' : `2px dashed ${COLOR.MAIN.FORM_FIELD_DARK}`};
        top: ${roundelSize / 2 - 1}px;
        right: -50%;
        z-index: 0;
        box-sizing: border-box;
    }

    &:last-child {
        &::after {
            content: none;
        }
    }

    ${StyledLabel} {
        animation: ${SPEED.TRANSITION} ${ANIMATION.FADE_IN} linear forwards;
    }
`;

export const StepProcess = ({ steps, currentStep, ...props }: StepProcessProps) => (
    <StyledStepProcess {...props}>
        {steps.map(
            (step: any, i: number) =>
                step &&
                !step.skipStep && (
                    <StyledStepItem
                        complete={i < currentStep}
                        active={i === currentStep}
                        childLength={steps.filter((item: any) => !item.skipStep).length}
                        key={step.key || i}
                    >
                        <StyledLabel>{step.title}</StyledLabel>
                    </StyledStepItem>
                ),
        )}
    </StyledStepProcess>
);
